import axios from "axios";
import Vue from "vue";
import router from "@/router";

// axios instance vyhradne pro OAuth - neni pak potreba resit problem s nastavenymi interceptory defaultniho axiosu,
// coz je vhodne predevsim pri zpracovavani chyby 401, aby se to nezacyklilo v pripade, ze i OAuth vrati 401
const authAxios = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 10000
});

const setCompany = function(state, code) {
  if (state.token == null || state.token.companies == null) {
    Vue.set(state, "company", null);
  } else {
    var company = state.token.companies.filter(x => x.code === code);

    if (state.company == null || state.company.code !== code || state.company.name === undefined) {
      if (company.length === 0)
        Vue.set(state, "company", state.token.companies[0]);
      else
        Vue.set(state, "company", company[0]);
    }
  }
};

const state = {
  /* struktura objektu user
  token: {
    accessToken: string,
    refreshToken: string,
    expiresIn: int,
    refreshExpiresIn: int,
    personId: int,
    firstName: string,
    lastName: string,
    superuser: boolean,
    companies: [
       {
          code: string,
          name: string,
          administrator: boolean,
          driver: boolean,
          dispatcher: boolean,
       },
       ...
    ]
  }
   */
  token: null,
  /* Trvalé přihlášení (je nutné se přihlásit jednou za 5 dní) */
  permanent: false,
  /* aktivní firma */
  company: null,
  /* kód firmy braný s routeru při každém volání  */
  companyRoute: null,
  /* token se aktualizuje */
  isRefreshing: false,
  refreshingCall: undefined
};

const getters = {
  token: state => state.token,
  company: state => state.company
};

const actions = {
  start({ getters, dispatch }) {
    // nastavime automaticke pridavani oauth tokenu ke vsem requestum z defaultniho axiosu (API).
    // Provede se to pouze jednou na zacatku a pak uz se to pouziva vzdy.
    axios.interceptors.request.use(request => {
      // pridame autorizacni token ke kazdemu volani API
      request.headers["Authorization"] = "Bearer " + getters.token.accessToken;
      request.headers["Tracking-Application"] = "webui@" + process.env.APPLICATION_VERSION;
      request.url = request.url.replace("{#company#}", getters.company.code);
      return request;
    });

    // nastavit automaticky refresh pri vyprseni platnosti tokenu (az dostaneme 401, tak se spusti refresh).
    // Automaticky refresh tokenu je postaveny na kombinaci nasledujicich odkazu, kde to uz nekdo resil a postupne daval dohromady.
    // https://github.com/axios/axios/issues/1674
    // https://github.com/Flyrell/axios-auth-refresh
    // https://stackoverflow.com/questions/51563821/axios-interceptors-retry-original-request-and-access-original-promise/51600050#51600050
    axios.interceptors.response.use(res => res, failedRequest => {
      const status = failedRequest.response ? failedRequest.response.status : null;
      if (status === 401) {
        // zavolat refresh tokenu. Spusti se pouze prvni, ostatni se navazou na ten stejny request (osetreno v refreshToken) a pockaji na jeho dokonceni
        return dispatch("refreshToken").then(() => {
          if (typeof failedRequest.config.wasFailed !== "undefined") {
            console.log("Repeated error 401 after refreshing token, some problem on server?", failedRequest);
            if (failedRequest.config.wasFailed++ >= 3) {
              console.log("Too many repeated errors in recursion, logout");
              // volani jiz zhavarovaneho pozadavku znovu skoncilo 401, pro preruseni cyklu to musime ukoncit
              dispatch("logout", {
                type: "error",
                message: "Byli jste automaticky odhlášeni z důvodu opakované autentizační chyby při odesílání stejného požadavku"
              });
              return Promise.reject(failedRequest);
            }
          } else {
            failedRequest.config.wasFailed = 1;
          }
          // nastavit novy token pozadavku, ktery spadl do 401
          failedRequest.response.config.headers["Authorization"] = "Bearer " + getters.token.accessToken;
          // a zavolat puvodni pozadavek znovu s opravenym tokenem a priznakem, ze uz jednou zhavaroval
          return axios.request(failedRequest.config);
        });
      }
      // ostatni chyby mimo 401 vyhodime dale jako kdyby tady nic nebylo
      return Promise.reject(failedRequest);
    });
  },

  login({ dispatch }, params) {
    var data = {
      username: params.username,
      password: params.password
    };

    if (params.permanent !== undefined)
      data.permanent = params.permanent;

    return dispatch("tokenRequest", data)
      .then(t => {
        return t;
      });
  },

  checkPassword({ dispatch }, params) {
    // kontrolu hesla zatim resit tak, jako by to byl novy login
    // ma to nevyhodu, ze po zadani spatneho hesla je uzivatel uplne odhlasen. Otazkou je, zda to je nevyhoda, nebo vlastne vyhoda.
    // Na jednu stranu je neprijemne, ze to cloveka odhlasi z aplikace po zadani spatneho hesla, na stranu druhou je to asi spravne...
    // Pripadne by to slo resit tak, ze se provede oauthRequest tak, aby nevyvolal logout pri chybe a jen ji vratil v promise.
    params.noActionLog = true;
    return dispatch("login", params);
  },

  refreshToken({ dispatch, state, commit }) {
    if (state.isRefreshing) {
      // pokud jiz probiha refresh, tak vratit ulozenou promisu s refreshem
      // console.log('token is already refreshing, skipping refresh')
      return state.refreshingCall;
    }

    commit("setRefreshing", true);
    // console.log('refreshing token')
    // data requestu pro refresh
    var data = {
      token: state.token.refreshToken
    };

    const refreshingCall = dispatch("tokenRequest", data).then((response) => {
      setTimeout(() => {
        // jeste par vterin se budeme tvarit, ze probiha refresh, i kdyz uz skoncil. Pozadavky, ktere spadnou
        // tesne po dokonceni refreshe pouziji stejnou promisu (ta uz bude splnena a pouze se spusti callback)
        // a nevyvolaji dalsi refresh tokenu. Mely by se navic opakovat okamzite, takze nezalezi, jak dlouhy
        // "ochranny interval" nastavime, pokud nebude prilis kratky.
        // console.log('refreshingCall done, leaving refreshing mode')
        commit("setRefreshing", false);
        commit("setRefreshingCall", undefined);
      }, 5000);
      return Promise.resolve(response);
    }).catch((error) => {
      dispatch("logout", { type: "error", message: "Byli jste automaticky odhlášeni z důvodu autentizační chyby" });
      return Promise.reject(error);
    });
    commit("setRefreshingCall", refreshingCall);
    return refreshingCall;
  },

  logout({ state, commit }) {
    // data requestu pro refresh
    if (state.token === null)
      commit("logout");
    else {
      return new Promise((resolve, reject) => {
        return authAxios
          .delete("/v1/all/token", {
            headers: { Authorization: `Bearer ` + state.token.refreshToken, "Tracking-Application": "webui" }
          })
          .then(() => {
            commit("logout");
          })
          .catch(error => {
            commit("logout");
            reject(error);
          });
      });
    }
  },

  tokenRequest({ commit, dispatch }, authData) {
    if (authData.permanent !== undefined)
      commit("setPermanent", authData.permanent);

    return new Promise((resolve, reject) => {
      return authAxios
        .get("/v1/all/token", Object.prototype.hasOwnProperty.call(authData, "token")
          ? {
            headers: {
              Authorization: `Bearer ` + authData.token,
              "Tracking-Application": "webui@" + process.env.APPLICATION_VERSION
            }
          }
          : {
            auth: {
              username: authData.username,
              password: authData.password
            },
            headers: {
              "Tracking-Application": "webui@" + process.env.APPLICATION_VERSION
            }
          })
        .then(response => {
          if (response.data.access === "normal" || response.data.access === "superuser") {
            // Musime ulozit uzivatele do storu, protoze token v tom objektu obsazeny je potreba pro nasledujici volani default axiosu
            commit("setToken", response.data);
            resolve(state.token);
          } else {
            dispatch("logout");
            reject();
          }
        })
        .catch(error => {
          var msg = "Neznámá chyba při autorizaci";
          if (typeof error !== "undefined" && typeof error.response !== "undefined") {
            if (typeof error.response.status !== "undefined" && error.response.status === 400 &&
              typeof error.response.data.error_description !== "undefined") {
              // pristup na OAuth je v poradku, ale uzivatel zadal spatne jmeno a heslo nebo nejaka jina chyba z OAuth
              msg = error.response.data.error_description;
            } else if (typeof error.response.data !== "undefined" && typeof error.response.data.message !== "undefined") {
              // zrejme doslo k jine chybe (sitove nebo mame spatne prihlasovaci udaje na OAuth nebo tak)
              msg = error.response.data.message;
            }
          } else if (typeof error !== "undefined" && typeof error.message !== "undefined") {
            msg = error.message;
          }
          dispatch("logout", { type: "error", message: "Autorizační chyba: " + msg });
          reject(error);
        });
    });
  },

  async setCompany({ commit, state }, companyCode) {
    if (state.token !== null) {
      // vyresetuj historii
      await this.dispatch("history/clear");
      // vyresetuj knihu jizd
      await this.dispatch("logbook/clear");
      // vyresetuj knihu jizd
      await this.dispatch("online/setVehicle", null);
      // vyresetuj skupinu
      await this.dispatch("groupsets/setGroupset", { id: null, fetch: false });

      // nastav firmu
      await commit("setCompany", companyCode);
      // aktualizace dat
      await this.dispatch("online/fetchVehicles");
    } else
      commit("setOnlyCompany", companyCode);
  }
};

const mutations = {
  setPermanent(state, permanent) {
    state.permanent = permanent;
    //Vue.set(state.permanent, "permanent", permanent);
  },

  setToken(state, token) {
    state.token = token;

    if (state.permanent)
      Vue.$cookies.set("token", { token: state.token.refreshToken, permanent: true }, "5d");
    else
      Vue.$cookies.set("token", { token: state.token.refreshToken, permanent: false }, 0);

    // zetrid firmy
    state.token.companies.sort((a, b) => a.name.localeCompare(b.name));

    if (token != null) {
      if (state.company === null || state.company === "-") {
        if (Vue.$cookies.isKey("company"))
          setCompany(state, Vue.$cookies.get("company"));
        else
          setCompany(state, "");
      } else
        setCompany(state, state.company.code);

      if (router.currentRoute.name === "automap")
        router.replace({ name: "map", params: { ccode: state.company.code } });
      else if (!router.checkPermissions(router.currentRoute))
        router.push({ name: "map", params: { ccode: state.company.code } });
    }
  },

  setCompany(state, code) {
    setCompany(state, code);

    Vue.$cookies.set("company", code, "14d");
    router.changeCompany(code);
  },

  setOnlyCompany(state, code) {
    state.company = { code: code };
  },

  logout(state) {
    // uklidit store - vsechny objekty nastavit do defaultu
    state.token = null;
    state.isRefreshing = false;
    state.refreshingCall = undefined;

    // odstranení cookie
    Vue.$cookies.remove("token");
  },

  setRefreshing(state, refreshing) {
    state.isRefreshing = refreshing;
  },

  setRefreshingCall(state, call) {
    state.refreshingCall = call;
  },

  setUserRoles(state, roles) {
    if (state.token) {
      Vue.set(state.token, "roles", roles);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
